import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {
  RouteHappyService,
  ModalOpenerService,
  FlightJourney,
  WithSubscriptionComponent
} from '@sabstravtech/obtservices/angular';
import {
  FlightItineraryWithExtensions,
  RouteHappyAmenities,
  FlightGroupedQuoteResult,
  Memorise,
  getTimeDifference
} from '@sabstravtech/obtservices/base';

import { LightningModalTypes } from '../../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-flight-legs-old',
  templateUrl: './flight-legs.component.html',
  styleUrls: ['./flight-legs.component.scss'],
  standalone: false
})
export class FlightLegsOldComponent extends WithSubscriptionComponent implements OnInit, OnDestroy {
  @Input() legs!: FlightJourney[];
  @Input() altColour!: boolean;
  @Input() flight!: FlightGroupedQuoteResult;
  @Input() FlightItineraryWithSelected!: FlightItineraryWithExtensions;
  amenitiesSubscription: any;
  amenitites: RouteHappyAmenities[] = [];
  constructor(
    private routeHappyService: RouteHappyService,
    private modalOpenerService: ModalOpenerService
  ) {
    super();
  }
  ngOnDestroy(): void {
    if (this.amenitiesSubscription) {
      this.amenitiesSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    console.log(this.legs, 'ITENERY');
    this.amenitites = [];
    this.amenitiesSubscription = this.subscribe(
      this.routeHappyService.getAmenitiesForFlight(this.flight),
      (amenitites: RouteHappyAmenities[]) => {
        this.amenitites = amenitites;
      }
    );
  }

  calculateTimeDifference(depDateTime: string, arrDateTime: string): number {
    return getTimeDifference(arrDateTime, depDateTime);
  }

  @Memorise()
  setIco(leg: FlightJourney): string {
    if (leg.equipmentCode === 'BUS') {
      return 'ico-bus';
    } else {
      return 'ico-flight';
    }
  }

  showFlightCosts(flight: FlightItineraryWithExtensions) {
    this.modalOpenerService
      .open(LightningModalTypes.FlightCostsComponent, {}, { costs: flight.total })
      .then();
  }
}
